import React from "react";
import { Route, Switch } from "react-router-dom";
import Login from "./containers/Login";

export default () =>
  <Switch>
    <Route path="/" exact component={Login} />
  </Switch>;



// WEBPACK FOOTER //
// ./src/Routes.js